import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["customFrom", "customTo", "groupBy"]

  toggleCustom(event) {
    const isCustom = event.target.value === "custom"

    this.customFromTarget.classList.toggle("hidden", !isCustom)
    this.customToTarget.classList.toggle("hidden", !isCustom)
    this.groupByTarget.classList.toggle("hidden", !isCustom)
  }
}
